module.exports = __webpack_public_path__ + "static/bg-min-13d0f7580a2c141d4f406fe293eea9e7.jpg";